import { cn } from "@/lib/utils";

interface CurrencyProps {
  value: number;
  currency: string;
  className?: string;
  showSign?: boolean;
  divide?: boolean; // Divide by 100 if backend sends cents
}

const currencySymbols: Record<string, string> = {
  NOK: "kr",
  SEK: "kr",
  EUR: "€",
  GBP: "£",
  USD: "$",
  BSD: "B$",
  FJD: "FJ$",
};

export function Currency({
  value,
  currency,
  className,
  showSign = false,
  divide = false,
}: CurrencyProps) {
  const amount = divide ? value / 100 : value;
  const formattedValue = new Intl.NumberFormat("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(Math.abs(amount));

  const symbol = currencySymbols[currency] || currency;
  const sign = showSign && amount !== 0 ? (amount > 0 ? "+" : "-") : "";

  return (
    <span
      className={cn("tw-inline-flex tw-items-baseline tw-gap-1", className)}
    >
      <span>
        {sign}
        {formattedValue}
      </span>
      <span className="tw-text-muted-foreground">{symbol}</span>
    </span>
  );
}

// Helper function for backward compatibility with existing code
export function formatCurrency(
  value: number,
  currency: string,
  divide = false
): {
  value: string;
  currency: string;
  sign: string;
} {
  const amount = divide ? value / 100 : value;
  const formattedValue = new Intl.NumberFormat("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(Math.abs(amount));

  const symbol = currencySymbols[currency] || currency;
  const sign = amount < 0 ? "-" : "";

  return {
    value: formattedValue,
    currency: symbol,
    sign,
  };
}
